import { render, staticRenderFns } from "./pageLogo.vue?vue&type=template&id=368f7cfb&scoped=true"
import script from "./pageLogo.vue?vue&type=script&lang=js"
export * from "./pageLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f7cfb",
  null
  
)

export default component.exports